import React from 'react'
import { connect } from 'react-redux'
import { fetchSetting } from '../../actions'
import { Field, reduxForm } from 'redux-form'
import { Link } from 'react-router-dom'
import renderInput from '../form/formInput'
import renderSelect from '../form/formSelect'

class CartItemForm extends React.Component {
  componentDidMount() {
    this.props.fetchSetting()
  }

  onSubmit = (formValues) => {
    this.props.onSubmit(formValues)
  }

  getUnits = (units) => {
    return units.map((x, index) => (
      <option key={index} value={x['unit']}>
        {x['unit']}
      </option>
    ))
  }

  getStores = (stores) => {
    return stores.map((x, index) => (
      <option key={index} value={x['store']}>
        {x['store']}
      </option>
    ))
  }

  render() {
    return (
      <form
        onSubmit={this.props.handleSubmit(this.onSubmit)}
        className="ui form error"
      >
        <Field
          name={`item`}
          type="text"
          component={renderInput}
          label={`Item`}
        />
        <Field
          name={`amount`}
          type="number"
          component={renderInput}
          label={`Amount purchased`}
        />
        <Field
          name={`cost`}
          type="number"
          component={renderInput}
          label={`Cost per Unit`}
        />
        <Field name={`unit`} component={renderSelect} label={`Unit`}>
          <option />
          {this.props.settings
            ? this.getUnits(this.props.settings.units)
            : null}
        </Field>

        <Field name={`store`} component={renderSelect} label={`Store`}>
          <option />
          {this.props.settings
            ? this.getStores(this.props.settings.stores)
            : null}
        </Field>

        <button className="ui button positive">Complete</button>
        <Link to="/shopping-list" className="ui button">
          Cancel{' '}
        </Link>
      </form>
    )
  }
}

const validate = (formValues) => {
  const errors = {}
  if (!formValues.item) {
    errors.item = 'You must enter an item'
  }
  if (!formValues.store) {
    errors.store = 'You must enter an store'
  }
  if (!formValues.amount) {
    errors.amount = 'You must enter a amount'
  }
  if (!formValues.unit) {
    errors.unit = 'You must enter an unit'
  }
  return errors
}

const mapStateToProps = (state) => {
  return { settings: state.settings[0] }
}

export default reduxForm({
  form: 'cartItemForm',
  validate,
})(connect(mapStateToProps, { fetchSetting })(CartItemForm))
